export const Ebooks_Details = 'Ebooks_Details';
export const Ebooks_Listing = 'Ebooks_Listing';
